import { Injectable } from '@angular/core';
 
import {SocketManagerProvider} from '../socket-manager/socket-manager';
import {UserManagerProvider} from '../user-manager/user-manager';
import * as Enums from '../../bayadic-shared-models/enums/Enums';
import * as Tools from '../../bayadic-shared-models/tools/Tools';
import { Events } from '../../providers/events/events';

/*
  Generated class for the EventsManagerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EventsManagerProvider {

  constructor(
    public socketManager : SocketManagerProvider,
    public userManager : UserManagerProvider,
    public events: Events,
      ) {
      events.subscribe(Enums.EVENTS.CheckEvents, (data, time) => {
          this.checkEvents();
      });
 
  }
  handleMessage(res){
      let result = JSON.parse(res);
      if (Tools.CHECK.isJson(result['msg']))
        {
          let events = JSON.parse(result['msg']);
          if (Array.isArray(events['events'])){
            for (let bayaEvent of events['events']){
              this.events.publish(bayaEvent['action'], JSON.parse(bayaEvent['data']), Date.now());
              this.socketManager.asyncQuery(
                  Enums.ACTIONS.DeleteEvent, 
                  events
                );
            }
          }
        }
  }
  checkEvents(){
      if (this.userManager.user != undefined)
        this.socketManager.asyncQuery("checkEvents", {});
  }

}
